import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";

import { lizardDateSchema } from "../dates";
import { paginatedSchema } from "../pagination";

/* Both raster and timeseries triggers use this schema! */
export const alarmTriggerSchema = z.object({
  id: z.number(),
  trigger_time: lizardDateSchema,
  value: z.number().nullable(),
  value_time: lizardDateSchema,
  warning_level: z.string().nullable(),
  threshold_value: z.number().nullable(),
  threshold_time: lizardDateSchema.nullable(),
  // Also 'first_time' (?) and 'message_sent', but we don't use them
});

export type Trigger = z.infer<typeof alarmTriggerSchema>;

export const alarmTriggerListSchema = paginatedSchema(alarmTriggerSchema);

export type TriggerList = z.infer<typeof alarmTriggerListSchema>;

export function useRasterAlarmTriggers(uuid: string) {
  const url = `/api/v4/rasteralarms/${uuid}/triggers/?page_size=1000`;
  return useParsedQuery<TriggerList>(
    ["lizard-api-v4", "rasteralarms", uuid, "triggers"],
    () => fetchWithError(url),
    (json: unknown) => alarmTriggerListSchema.parse(json)
  );
}

export function useMultipleRasterAlarmsTriggers(uuids: string[]) {
  return useParsedQueries(
    uuids.map((uuid) => {
      return {
        queryKey: ["lizard-api-v4", "rasteralarms", uuid, "triggers"],
        fetchFunction: () =>
          fetchWithError(`/api/v4/rasteralarms/${uuid}/triggers/?page_size=1000`),
        parseFunction: (json: unknown) => alarmTriggerListSchema.parse(json),
      };
    })
  );
}
